import React, { useEffect } from "react";
import "./Looser_Modal.css";
import { Modal } from "react-bootstrap";
import { formatAmount, getBetSummary } from "../../../../../utils/common";

function Looser_Modal({ resultData, lossBets, onHide, show, ...props }) {

  const summary = getBetSummary(lossBets);


  return (
    <Modal
      {...props}
      show={show}
      onHide={onHide}
      centered
      size="sm"
      backdrop="static"
      className="Winner_Modal Looser_Modal Common_modal"
    >
      <Modal.Body>
        <div className="winner_content_holder Looser_Modal_content_holder">
          <div className="img_holder">
            <img
              src="/assets/images/looser_modal/bg.png"
              className="bg_img"
              alt="bg"
            />

            {/* Result */}


            <div className="result_box">
              {summary?.bets?.map((data) => (<>
                {/* <span className="number">2</span>
                <span className="result_color loose_box"></span>
                <span className="type">Small</span> */}
                {data?.bet_type === "number" && (<span className="number">{data?.bet_on}</span>)}
                {data?.bet_type === "color" && (<span className={`result_color ${data?.bet_on?.toLowerCase()}`} ></span >)}
                {data?.bet_type === "size" && (<span className="type">{data?.bet_on}</span>)}
              </>
              ))}
            </div>

            {/* Period */}
            <div className="period_text">
              Period: {resultData?.Period?.period || ""}
            </div>

            {/* Win Amount */}
            <div className="amount_box">
              <img
                src="/assets/images/icons/rupee.png"
                alt="coin"
                className="coin_icon"
              />
              <span>{formatAmount(summary?.totalLoss)}</span>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal >
  );
}

export default Looser_Modal;